<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import OffersApi from "@/services/offers-api";
import Swal from "sweetalert2";
import OrdersApi from "@/services/orders-api";

export default {
  props: {
      activeTab :{
          type :Number,
          default : 0
      }

  },

  page: {
    title: "Liste des Offres",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: { Layout },

  beforeMount(){
    this.getSuppliersOfferType();
  },

  mounted()
    {
      if(this.activeTab == 1){
        this.openInActiveTab()
      }else{
        this.openActiveTab()
      }
    },

  data() {
    return {
      pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
      Inactivepagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
      isTableLoading:false,
      promotionsList: [],
      promotionsFields: [
      {key:"title", label: "Intitulé de l'Offre", sortable: false, tdClass:"font-weight-bold"},
      {key:"formattedPublishDate", label:"Date de publication", sortable:false,thClass:"text-left d-md-table-cell d-none" ,tdClass:"text-left d-md-table-cell d-none" },
      {key:"formattedstartDate", label:"Date de début", sortable:false,thClass:"text-left d-md-table-cell d-none" ,tdClass:"text-left d-md-table-cell d-none"},     
      {key:"formattedendDate", label:"Date de fin", sortable:false,thClass:"text-left d-md-table-cell d-none" ,tdClass:"text-left d-md-table-cell d-none"},
      {key:"type", label: "Type",sortable:false,thClass:"text-left d-md-table-cell d-none" ,tdClass:"text-left d-md-table-cell d-none"},
      {key:'actions', label:'Publier/Retirer',thClass:"text-center" ,tdClass:"text-center"},
      {key:'export', label:'Commandes',thClass:"text-center" ,tdClass:"text-center"},
      {key:'delete', label:'Supprimer',thClass:"text-center" ,tdClass:"text-center"}],
      suppliersOfferType:null,

      isDownloadPurchaseOrdersInProgress: false
    };
  },

  methods: {

    exportPurchaseOrder(offer){
      this.isDownloadPurchaseOrdersInProgress= true
      OrdersApi.exportPurchaseOrder(offer).then(() => {
        this.isDownloadPurchaseOrdersInProgress= false;
        }).finally(() => {
          this.isDownloadPurchaseOrdersInProgress= false;
        }
        );
    },

    getSuppliersOfferType(){
     OffersApi.getSuppliersOfferType()
        .then(response => {
          this.suppliersOfferType= response;
        })
        

      },
    openActiveTab(){
      this.$refs['active-tab'].activate()
      this.pagemodel= {currentPage : 1, perPage : 10, totalRows: 0}
      this.isTableLoading=false
      this.promotionsList= []
      this.getActivePromotions();
    },

    openInActiveTab(){
      this.$refs['inactive-tab'].activate()
      this.Inactivepagemodel= {currentPage : 1, perPage : 10, totalRows: 0}
      this.isTableLoading=false
      this.promotionsList= []
      this.getInactivePromotions();
    },

    getActivePromotions(){
      this.isTableLoading = true;
      OffersApi.getOffers(true,this.pagemodel.currentPage, this.pagemodel.perPage,null,null,null)
        .then(response => {
          this.promotionsList = response.list
          this.pagemodel.totalRows = response.total;
          this.pagemodel.currentPage = response.page;
          this.pagemodel.perPage = response.pageSize;
          this.pagemodel.pageSize = response.pageSize;
        })
        .finally(() => {
        this.isTableLoading = false;
      })
    },
    getInactivePromotions(){
      this.isTableLoading = true;
      OffersApi.getOffers(false,this.Inactivepagemodel.currentPage, this.Inactivepagemodel.perPage,null,null,null)
        .then(response => {
          this.promotionsList = response.list
          this.Inactivepagemodel.totalRows = response.total;
          this.Inactivepagemodel.currentPage = response.page;
          this.Inactivepagemodel.perPage = response.pageSize;
          this.Inactivepagemodel.pageSize = response.pageSize;
        })
        .finally(() => {
        this.isTableLoading = false;
      })
    },
    changeActivation(item){
          Swal.fire({
            title: item.isActive ? "Retirer l'offre ?" : "Publier l'offre ?",
            html:item.isActive ?"L'offre <strong class='text-danger'> ne sera plus visible </strong> aux clients!" : "Vous <strong class='text-danger'> ne pouvez plus modifier les articles et les remises de </strong> l'offre aprés activation! "  ,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Annuler",
            confirmButtonText: "Confirmer"
      }).then(result => {
          if (result.value) {
          OffersApi.changeActivation(item).then(
          result =>{
            if (result) {
              if(!item.isApplicable && !item.isActive){
                this.openActiveTab()
              }else {
                this.openInActiveTab()
              }
            }else {
              this.openInActiveTab()
            }
          }
        )
          }
      }
      )
    },
    deleteOffer(offer){
      Swal.fire({
        title:  "Supprimer l'offre définitivement ?" ,
        html:"Supprimer l'offre définitivement ?"  ,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: "Annuler",
        confirmButtonText: "Confirmer"
  }).then(result =>{
    if(result){
      OffersApi.deleteOffer(offer).then(
        ()=>{
          if(offer.isActive){
            this.getActivePromotions();
          }else{
            this.getInactivePromotions();
          }
        }
      )
    }
  }

  )

    },
  }
}

</script>
<template>
  <Layout>
    <div class="row pt-4">
      <div class="col-lg-12">
        <div class="card border border-light">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-10" >
                <h2 class="card-title font-size-25" style="font-size:25px;">Liste des Offres</h2>
                <p class="card-title-desc font-size-14">
                  La Liste des Offres et Promotions
                </p>
              </div>
              <div class="col-sm-2 pb-4 text-right" >
                 
                <router-link :to="{ path: '/promotions/new', query: { suppliersOfferType: suppliersOfferType }}">
                  <b-button variant="primary">
                    <i class="fas fa-plus-square font-size-18 font-weight-bold align-middle mr-2 "></i> <span class=" font-weight-bold ">Ajouter</span>
                  </b-button>
                </router-link>
              </div>
            </div>
          <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
              <b-tab ref="active-tab" active class="border-0" @click="openActiveTab()">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-calendar-check"></i>
                  </span>
                  <span class="d-none d-sm-inline-block font-size-16"><i class="fas fa-calendar-check mr-2"/> Offres en cours</span>
                </template>

                <div class="table-responsive">
              <b-table 
                :busy="isTableLoading"
                :striped="true"
                :small="false"
                :hover="true"
                :items="promotionsList"
                :fields="promotionsFields"
                class="table mt-4"
              >
              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
              </template>
              <template v-slot:cell(title)="{item ,value}">
                
                <router-link :to="{ path: '/promotions/new', query: { promotionId: item.id,suppliersOfferType: suppliersOfferType  }}">
                    <a  href="javascript:void(0)">{{value}}</a>
                </router-link>
              </template>

              <template #head(title)="">
                Intitulé <span class="d-none d-sm-inline-block"> de l'Offre</span>
              </template>

              <template v-slot:cell(type)="{value}">
                <span
                  style="font-size:14px; min-width:90px;"
                  class="badge"
                  :class="{ 'badge-primary': value == 1,
                            'badge-warning': value == 0}"
                >{{value===0 ? 'Provisoire' :  'Permenante' }}</span>
              </template>

              <template v-slot:cell(formattedstartDate)="{value}">
                {{value===null ? "-"  : value}}
              </template>

              <template v-slot:cell(formattedendDate)="{value}">
                {{value===null ? "-" : value}}
              </template>


              <template v-slot:cell(formattedPublishDate)="{value}">
                {{value===null ? "-" : value}}
              </template>


              <template v-slot:cell(export)="{item}">
                <b-button @click="exportPurchaseOrder(item)" size="sm" variant="outline-primary" ><i v-b-tooltip.hover title="Télécharger" class="fas fa-download"></i></b-button>
              </template>


              <template v-slot:cell(actions)="{item}">
                <b-button @click="changeActivation(item)" v-model="item.isActive" size="sm" :variant="item.isActive ? 'outline-dark' : 'outline-danger'" >
                  <i class="fas fa-power-off font-size-16 align-middle mr-2"></i>{{item.isActive ? "Retirer l'offre" : "Publier l'offre"}} 
                </b-button>                <!-- <switches v-model="item.isActive" :color="item.isActive ? 'primary' : 'secondary'" class="pt-3" @click="$refs[item.id].click()"  ></switches> -->
              </template>

              <template v-slot:cell(delete)="{item}">
                <a  title="supprimer" href="javascript:void(0);"  @click="deleteOffer(item)"  class="action-icon text-danger " >
                    <i class="mdi mdi-trash-can font-size-22 " />
                </a>
              </template>
              </b-table>
              <span v-if="!isTableLoading && !promotionsList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune offre dans la liste</span>

            <!-- Pagination -->
            <div class="row pt-3 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="getActivePromotions()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodel.totalRows}} lignes</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="pagemodel.currentPage" :disabled="isTableLoading" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getActivePromotions()" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->
                </div>
              </b-tab>
              <b-tab ref="inactive-tab" class="border-0" @click="openInActiveTab()">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-calendar-times"></i>
                  </span>
                  <span class="d-none d-sm-inline-block font-size-16"><i class="fas fa-calendar-times mr-2"/> Offres Inactives</span>
                </template>
                
                <div class="table-responsive">
              <b-table 
                :busy="isTableLoading"
                :striped="true"
                :small="false"
                :hover="true"
                :items="promotionsList"
                :fields="promotionsFields"
                class="table mt-4"
              >
              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
              </template>

              <template v-slot:cell(title)="{item ,value}">
                <router-link :to="{ path: '/promotions/new', query: { promotionId: item.id ,suppliersOfferType: suppliersOfferType }}">
                    <a  href="javascript:void(0)">{{value}}</a>
                </router-link>
              </template>
              <template #head(title)="">
                Intitulé <span class="d-none d-sm-inline-block"> de l'Offre</span>
              </template>

              
              <template v-slot:cell(export)="{item}">
                <b-button @click="exportPurchaseOrder(item)" size="sm" variant="outline-primary" ><i v-b-tooltip.hover title="Télécharger" class="fas fa-download"></i></b-button>
              </template>


              <template v-slot:cell(type)="{value}">
                <span
                  style="font-size:14px; min-width:90px;"
                  class="badge"
                  :class="{ 'badge-primary': value == 1,
                            'badge-warning': value == 0}"
                >{{value===0 ? 'Provisoire' :  'Permenante' }}</span>
              </template>
              <template v-slot:cell(formattedstartDate)="{value}">
                {{value===null ? "-" : value}}
              </template>
              <template v-slot:cell(formattedendDate)="{value}">
                {{value===null ? "-" : value}}
              </template>
              <template v-slot:cell(formattedPublishDate)="{value}">
                {{value===null ? "-" : value}}
              </template>
              <template v-slot:cell(actions)="{item}">
                <b-button @click="changeActivation(item)" v-model="item.isActive" size="sm" :variant="item.isActive ? 'outline-dark' : 'outline-danger'"  >
                  <i class="fas fa-power-off font-size-16 align-middle mr-2"></i>{{item.isActive ? "Retirer l'offre" : "Publier l'offre"}} 
                </b-button> 
              </template>
              <template v-slot:cell(delete)="{item}">
                <a  title="supprimer" href="javascript:void(0);"  @click="deleteOffer(item)"  class="action-icon text-danger " >
                    <i class="mdi mdi-trash-can font-size-22 " />
                </a>
              </template>
              </b-table>
              <span v-if="!isTableLoading && !promotionsList.length" class="d-flex justify-content-center m-4 text-danger" >Aucune offre dans la liste</span>

            <!-- Pagination -->
            <div class="row pt-3 mb-sm-4">
                <div class="col-sm-8">
                    <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                        <b-form-select @input="getInactivePromotions()"  v-model="Inactivepagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                        <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{Inactivepagemodel.totalRows}} lignes</span></div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                        <b-pagination v-model="Inactivepagemodel.currentPage" :disabled="isTableLoading" :per-page="Inactivepagemodel.pageSize" :total-rows="Inactivepagemodel.totalRows" @input="getInactivePromotions()" ></b-pagination>
                        </ul>
                    </div>
                </div>
            </div> 
            <!-- Fin Pagination  -->
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>


    <b-modal  
        v-model="isDownloadPurchaseOrdersInProgress" 
        hide-footer 
        hide-header 
        centered  
        no-close-on-esc   
        no-close-on-backdrop  
    >
    <div class="zoom-container">
      <div class="text-center font-size-18">Veuillez patienter pendant que nous exportons la liste des commandes</div><br>
      <div class="d-flex justify-content-center">
        <div class="spinner-border text-success" role="status">
        </div>
      </div> 
    </div>   
    </b-modal>

  </Layout>
</template>